import { convertDigitToProperFormat } from '../../../utils/number';
import {
  getLangFromLocalStorage,
  getLanguageBaseOnTZ,
} from '../../../utils/LanguageLocalStorage';
import i18n from '../../../i18n';

const messages = {
  addMemberRole: 'سمت ‌های کاربر',
  addMemberToCompany: 'افزودن کاربر به شرکت',
  areYouSure: 'آیا از انجام این کار مطمئن هستید؟',
  cancel: 'لغو',
  confirm: 'تأیید',
  companies: 'شرکت‌ها',
  companiesList: 'فهرست شرکت‌ها',
  companyCreated: 'شرکت مورد نظر با موفقیت ایجاد شد',
  companyEdited: 'شرکت با موفقیت ویرایش شد',
  companyEditor: 'ویرایشگر شرکت',
  companyMembers: 'اعضای شرکت',
  companyTitle: 'عنوان شرکت',
  configuration: 'پیکربندی',
  create: 'ساختن',
  createNewCompany: 'ایجاد شرکت جدید',
  createNewTemplate: 'ایجاد قالب جدید',
  delete: 'غیر فعال سازی',
  admin: 'مدیر',
  inactive: 'غیر فعال',
  restore: 'فعال سازی',
  deactivate: 'غیر فعال سازی',
  addPrefixeRoles: 'افزودن تمام نقش‌‌های پیش‌وند',
  noPrefixedRoleFound: 'هیچ سمت که این سمت پیشوند آن باشد وجود ندارد',
  projectMemberRemoved: 'کاربر از این پروژه حذف شد',
  excel: 'خروجی اکسل',
  allProjects: 'همه پروژه ها',
  phonePlaceHolder: '09123456789',
  newPhoneNumber: 'تلفن جدید',
  userUpdated: 'کاربر به روز شد',
  errorChangePhone: 'خطا در تغییر شماره تلفن',
  subs: 'زیرمجموعه‌ها',
  roleIsUnique: 'فقط یک فرد می‌تواند به این سمت منصوب شود',
  addMemberPost: 'سمت فرد',
  addMemberDistrict: 'بخش محل فعالیت',
  dismissErrorView: 'نمایش همه کاربران',
  exactly1MemberShouldBeAssigned: '* این سمت به بیش از یک نفر محول شده است',
  missingTag: ' * این بخش به هیچ تگی متصل نیست',
  noOneAssigned: '* این سمت به هیچ فردی محول نشده است ',
  memberPost: 'سمت فرد',
  memberDistrict: 'بخش محل فعالیت فرد',
  userAdmin: 'مدیریت کاربران',
  showThem: 'نمایش بده',
  roleWithError: 'سمت مشکل دار',
  error: 'شرح مشکل',
  actions: 'عملیات پیشنهادی',
  findUserAndAddRole:
    'کاربر مورد نظر را از لیست کاربران بیابید و این سمت را به آن اضافه کنید',
  foundSimilarPersons:
    'افرادی با نام مشابه وجود دارند لطفا مطمئن شوید که فرد تکراری اضافه نمی‌کنید:',
  currentMemberRoles:
    'سمت های کنونی کاربر (اگر موردی اضافی هست پاک کنید تا اعمال شود)',
  employeeId: 'کد پرسنلی',
  roles: 'سمت ها',

  addRole(name: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa') return `افزودن بخش زیر مجموعه ${name}`;
    else return `Add sub-district under ${name}`;
  },

  deleteUserFromCompany(memberName: string) {
    return `${memberName} از لیست کاربران حذف شود؟`;
  },
  memberRemoved(memberName: string) {
    const lang = getLangFromLocalStorage();
    if (lang === 'fa') return `${memberName} با موفقیت از شرکت حذف شد`;
    else return `${memberName} successfully deleted`;
  },
  members: 'اعضا',
  noRolesToAdd: 'سمتی برای اضافه شدن وجود ندارد',
  projects: 'پروژه‌ها',
  save: 'ذخیره',
  searchUserByPhoneNumber: 'شماره تلفن کاربر را وارد کنید',
  tasks: 'وظیفه‌ها',
  templates: 'قالب‌ها',
  thereIsNoMemberYet: 'هنوز کاربری به عنوان عضو اضافه نشده است',
  userName: 'نام و نام خانوادگی کاربر',
  userPhoneNumber: 'شماره همراه',
  headerLastNameColumn: 'نام خانوادگی',
  phoneNumberExists: 'شماره تلفن قبلاً اضافه شده است',
  countOfMembers: 'تعداد: ',
  gotIt: 'متوجه شدم',
  forceRename: 'تغییر نام قبلی',
  selectARole: 'لطفاً سمتی را انتخاب نمایید...',
  searchByName: 'جستجو بر اساس نام',
  userNameHint: 'مثال: علی احمدی',
  membersCount: 'تعداد کاربران: ',
  searchByRole: 'جستجو بر اساس نام/سمت/تلفن',
  inviteMembersSuccess(memberCount: string, companyName: string) {
    return i18n.t('inviteMembersSuccess', {
      ns: 'companyManagement',
      memberCount,
      companyName,
    });
  },
  conflictUser(importName: string, existsName: string) {
    return i18n.t('conflictUser', {
      ns: 'companyManagement',
      importName,
      existsName,
    });
  },
  inviteMembers(isMultiple: boolean) {
    return isMultiple
      ? i18n.t('inviteUsers', { ns: 'companyManagement' })
      : i18n.t('inviteUser', { ns: 'companyManagement' });
  },
  membersList: 'لیست کاربران',
  memberAddedToCompany(memberName: string, companyName: string) {
    return `${memberName} به ${companyName} اضافه شد`;
  },
  invitePhoneNumber(phoneNumber: string) {
    return `دعوت شماره تلفن ${phoneNumber}`;
  },
  confirmAddPrefixRoles(name: string, othernames: string) {
    return `ایا مطمئن هستید که سمت «${name}» را به تمام افرادی که هر یک از سمت های «${othernames}» را دارند اضافه کنید؟ `;
  },
  confirmRemoveUserWithUsedRoles(projects: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `این کاربر در پروژه‌های ${projects}  با این سمت حضور دارد ایا مطمئن هستید که می‌خواهید این سمت را حذف کنید؟`;
    else
      return `This user is assigned to the projects ${projects} with this role. Are you sure you want to remove this role?`;
  },
  usersWithErrorFound(n: number) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `اطلاعات ${convertDigitToProperFormat(n)} کاربر ناقص است `;
    else
      return `The information of ${convertDigitToProperFormat(n)} user is incomplete`;
  },
  rolesWithErrorFound(n: number) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `اطلاعات ${convertDigitToProperFormat(n)} سمت  ناقص است `;
    else
      return ` The information of ${convertDigitToProperFormat(n)} role is incomplete`;
  },
  usedInProjectsButEmpty(projectName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return ` * این سمت در پروژه ${projectName} استفاده شده است اما هیج فردی آن را عهده‌ دار نیست`;
    else
      return `* This role is used in the project ${projectName}, but no one is assigned to it.`;
  },
};

export default messages;
